import {HashRouter as  Link  } from 'react-router-dom'
import {Button} from 'react-bootstrap'

export default function MenuPage(props) {
    return <div className="App-menu">
    
    </div>
}
